if (!customElements.get('scroll-to-top-btn')) {
  customElements.define(
    'scroll-to-top-btn',
    class ScrollToTopBtn extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold) || 400;
        this.onScroll = this.updateVisibility.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateVisibility();

        this.querySelector('button').addEventListener('click', () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        // Sit above the sticky add-to-cart bar while it is showing, so the two never overlap.
        this.stickyAtc = document.querySelector('sticky-atc');
        if (this.stickyAtc) {
          this.stickyObserver = new MutationObserver(this.updateStickyOffset.bind(this));
          this.stickyObserver.observe(this.stickyAtc, { attributes: true, attributeFilter: ['class'] });
          this.updateStickyOffset();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.stickyObserver) this.stickyObserver.disconnect();
      }

      updateVisibility() {
        this.hidden = window.scrollY <= this.threshold;
      }

      updateStickyOffset() {
        const visible = this.stickyAtc.classList.contains('sticky-atc--visible');
        this.style.setProperty('--sticky-atc-offset', visible ? `${this.stickyAtc.offsetHeight}px` : '0px');
      }
    }
  );
}
